import { StandaloneAppConfig } from '@/StandaloneAppConfig';

export async function reactScan() {
  const response = await fetch('/environment');
  const data = (await response.json()) as StandaloneAppConfig;

  if (data.ENABLE_PROFILING) {
    const { scan } = await import('react-scan');
    scan({
      enabled: true,
      dangerouslyForceRunInProduction: true,
    });
  }
}

reactScan();
